import databaseHandler from './database.js';

export default class UserHandler {
  constructor({
    hooks       = null,
    settings    = null
  } = {}) {

    console.log('UserHandler constructor...');
    this.cache    = {}
    this.token = '';
    this.url = '';
    this.status = '';
    this.profile = null;
    this.refresh_url = '';
    this.initial_load = false;
    this.local_db = false;
    this.last_checked_online=false;
    this._offline=false;
    this.offline_user=false;
  }

  async init(url,refresh,settings)
  {
    this.refresh_url = refresh;
    this.settings=settings;

    let _this = this;

    this.url = url;
    this.initial_load = true;

    let _log = this._log;

    if(!('online_check_url' in this.settings) || this.settings.online_check_url===false)
    {
      if('app_path' in this.settings)
      {
        this.settings.online_check_url=(this.settings.app_path.endsWith('/') ? this.settings.app_path.slice(0, -1) : this.settings.app_path)+'/manifest.part.json';
      }
      else
      {
        this.settings.online_check_url=false;
      }
    }

    if(!('online_check_timeout' in this.settings))
    {
      this.settings.online_check_timeout='5000';
    }

    this.env = {
        init:function(force)
        {
          try
          {
            if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4)))
            {
                this.isMobile = true;
            }
            else
            {
                this.isMobile = false;
            }


            // Check for cookies
            this.cookieEnabled = navigator.cookieEnabled;
            if (!this.cookieEnabled){
                document.cookie = "testcookie";
                this.cookieEnabled = document.cookie.indexOf("testcookie")!=-1;
            }

            // Check for PWA support
            this.pwa_supportsmanifest = ('relList' in HTMLLinkElement.prototype && document.createElement('link').relList.supports('manifest')?true:false);

            //Set Useragent
            this.userAgent=navigator.userAgent;

            // Set Browser
            this.browser='unknown';
            if (/rv:11.0/i.test(navigator.userAgent)) {
                this.browser="IE";
            }

            if (/MSIE 10/i.test(navigator.userAgent)) {
                this.browser="IE_10";
            }
            else if (/MSIE 9/i.test(navigator.userAgent)) {
                this.browser="IE_9";

            }else if (/Edge\/\d./i.test(navigator.userAgent)){
              this.browser="IE_EDGE";
            }

            if(navigator.userAgent.includes('Chrome') &&
            !navigator.userAgent.includes('Chromium') &&
            !navigator.userAgent.includes('OPR') &&
            !navigator.userAgent.includes('Edge') &&
            !navigator.userAgent.includes('SamsungBrowser'))
            {
                this.browser="Chrome";
            }

            if(navigator.userAgent.includes('SamsungBrowser'))
            {
                this.browser="SamsungBrowser";
            }

            if(navigator.userAgent.includes('Firefox') || navigator.userAgent.includes('Seamonkey') || navigator.userAgent.includes('Focus'))
            {
                this.browser="Firefox";
            }


            if(navigator.userAgent.includes('Safari') &&
            !navigator.userAgent.includes('Chrome') &&
            !navigator.userAgent.includes('Chromium') &&
            !navigator.userAgent.includes('Android'))
            {
                this.browser="Safari";
                if(navigator.userAgent.includes('CriOS'))
                {
                  this.browser="Safari/Chrome";
                }
                else if(navigator.userAgent.includes('FxiOS'))
                {
                  this.browser="Safari/Firefox";
                }
                else if(navigator.userAgent.includes('DuckDuckGo'))
                {
                  this.browser="Safari/DuckDuckGo";
                }
                else if(navigator.userAgent.includes('EdgiOS'))
                {
                  this.browser="Safari/EdgiOS";
                }

            }

            // Set OS
            this.OS = 'unknown';
            let clientStrings = [
                {s:'Windows 10', r:/(Windows 10.0|Windows NT 10.0)/},
                {s:'Windows 8.1', r:/(Windows 8.1|Windows NT 6.3)/},
                {s:'Windows 8', r:/(Windows 8|Windows NT 6.2)/},
                {s:'Windows 7', r:/(Windows 7|Windows NT 6.1)/},
                {s:'Windows Vista', r:/Windows NT 6.0/},
                {s:'Windows Server 2003', r:/Windows NT 5.2/},
                {s:'Windows XP', r:/(Windows NT 5.1|Windows XP)/},
                {s:'Windows 2000', r:/(Windows NT 5.0|Windows 2000)/},
                {s:'Windows ME', r:/(Win 9x 4.90|Windows ME)/},
                {s:'Windows 98', r:/(Windows 98|Win98)/},
                {s:'Windows 95', r:/(Windows 95|Win95|Windows_95)/},
                {s:'Windows NT 4.0', r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
                {s:'Windows CE', r:/Windows CE/},
                {s:'Windows 3.11', r:/Win16/},
                {s:'Android', r:/Android/},
                {s:'Open BSD', r:/OpenBSD/},
                {s:'Sun OS', r:/SunOS/},
                {s:'Chrome OS', r:/CrOS/},
                {s:'Linux', r:/(Linux|X11(?!.*CrOS))/},
                {s:'iOS', r:/(iPhone|iPad|iPod)/},
                {s:'Mac OS X', r:/Mac OS X/},
                {s:'Mac OS', r:/(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
                {s:'QNX', r:/QNX/},
                {s:'UNIX', r:/UNIX/},
                {s:'BeOS', r:/BeOS/},
                {s:'OS/2', r:/OS\/2/},
                {s:'Search Bot', r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
            ];
            for (let id in clientStrings) {
                let cs = clientStrings[id];
                if (cs.r.test(navigator.userAgent)) {
                    this.OS = cs.s;
                    break;
                }
            }

            this.OSVersion = 'unknown';


            if (/Windows/.test(this.OS)) {
                this.OSVersion = /Windows (.*)/.exec(this.OS)[1];
                this.OS = 'Windows';
            }

            switch (this.OS) {
                case 'Mac OS':
                case 'Mac OS X':
                     this.OSVersion = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([\.\_\d]+)/.exec(navigator.userAgent)[1];
                     break;
                case 'Android':
                    this.isMobile = true;
                    this.OSVersion = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([\.\_\d]+)/.exec(navigator.userAgent)[1];
                    break;
                case 'iOS':
                    this.isMobile = true;
                    this.OSVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
                    this.OSVersion = this.OSVersion[1] + '.' + this.OSVersion[2] + '.' + (this.OSVersion[3] | 0);
                    break;
            }

            if (/Mac OS/.test(this.OS) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1) {
              this.OS = 'iOS';
              this.isMobile = true;
            }

            this.OS = this.OS.replace(' ','').toLowerCase();
            this.OSVersion = this.OSVersion.replace(' ','').toLowerCase();
            this.browser = this.browser.replace(' ','').toLowerCase();

          }
          catch(ex)
          {
            _this._log("error","env.init",ex);
          }

          this.viewPortSizes = {};
        },
        get: function()
        {
          return {'os':this.OS,
            'os_version':this.OSVersion,
            'browser':this.browser,
            'viewport': this.viewPort,
            'pwa_support':{'manifest':this.pwa_supportsmanifest},
            'is_mobile':this.isMobile,
            'isInstalled':this.isInstalled,
            'userAgent':this.userAgent
          };
        },
        getOS: function()
        {
          return this.OS;
        },
        getOSVersion: function()
        {
          return this.OSVersion;
        },
        isInstalled:function()
        {
          let result = false;
          // For iOS
          if(window.navigator.standalone)
          {
              result = true;
          }

          // For Android
          if(window.matchMedia('(display-mode: standalone)').matches)
          {
              result = true;
          }
          return result;

        },
        print: function()
        {
          _this._log("info","env.getOS/env.getOSVersion/env.userAgent/env.Browser",this.getOS()+'/'+this.getOSVersion()+'/'+this.userAgent+'/'+this.browser);
          _this._log("info","env.isInstalled",this.isInstalled());
          _this._log("info","env.getViewport","Width:"+window.innerWidth+', Viewport is '+this.viewPort);
          _this._log("info","env.getDimentions","fullheight:"+this.dimentions.fullheight+', fullwidth:'+this.dimentions.fullwidth);
        },
        refreshViewPort:function(){
          let dsb_app_defines = document.createElement("div");
          dsb_app_defines.setAttribute('id','dsb_app_defines');
          dsb_app_defines.innerHTML = `<div id="dsb_app_defines-large" class="define-large"></div><div id="dsb_app_defines-medium" class="define-medium"></div><div id="dsb_app_defines-small" class="define-small"></div><div id="dsb_app_defines-xsmall" class="define-xsmall"></div>`;
          document.querySelector('dsb-app').append(dsb_app_defines);
          this.viewPortSizes.large=document.getElementById( "dsb_app_defines-large" ).offsetWidth;
          this.viewPortSizes.medium=document.getElementById( "dsb_app_defines-medium" ).offsetWidth;
          this.viewPortSizes.small=document.getElementById( "dsb_app_defines-small" ).offsetWidth;
          this.viewPortSizes.xsmall=document.getElementById( "dsb_app_defines-xsmall" ).offsetWidth;
          document.getElementById( "dsb_app_defines" ).remove();
          this.dimentions={};
          this.dimentions.fullheight=getComputedStyle(document.documentElement).getPropertyValue('--fullheight');
          this.dimentions.fullwidth=getComputedStyle(document.documentElement).getPropertyValue('--fullheight');
          this.getDimentions();
          this.isInstalled();
          this.getOS();
          this.getOSVersion();
          this.print();
          return this.getViewport(true);
        },
        getViewport:function(force){
          if(force)
          {
              var width = window.innerWidth;
              if(width<=this.viewPortSizes.medium && width>this.viewPortSizes.small)
              {
                  this.viewPort='medium';
              }
              else if(width<=this.viewPortSizes.small && width>this.viewPortSizes.xsmall)
              {
                  this.viewPort='small';
              }
              else if(width<=this.viewPortSizes.xsmall)
              {
                  this.viewPort='xsmall';
              }
              else
              {
                  this.viewPort='large';
              }
          }
          return this.viewPort;
        },
        getDimentions:function(force){
          return this.dimentions;
        },
        isViewport: function(_portSize)
        {
          let portSize = [];
          if(!Array.isArray(_portSize))
          {
            portSize.push(_portSize );
          }
          else
          {
            portSize = _portSize;
          }

          for(let i = 0; i < portSize.length; i++)
          {
            //console.log("testing.."+this.viewPort.toLowerCase()+" == "+portSize[i].toLowerCase());
            if(this.viewPort.toLowerCase()===portSize[i].toLowerCase())
            {
                return true;
            }
          }
          return false;
        },
    };
    this.env.init();

    window.onresize = function() {
        _this.env.getViewport(true);
        _this.env.print();
      }

    // Listen to ServiceWorker
    window.addEventListener("fw-pwa-serviceworker_event", e => {
        try
        {
          if(('detail' in e) && ('type' in e.detail))
          {
            switch(e.detail.type)
            {
              case "event":
                switch(e.detail.data)
                {
                  case "offline":
                    //_this._log('debug','fw-pwa-serviceworker_event','Offline Mode set.');
                    //_this.last_checked_online = Math.floor(+new Date() / 1000);
                    //_this.offline=true;
                    _this.is_offline(true);
                    break;
                  case "online":
                    //_this._log('debug','fw-pwa-serviceworker_event','Online Mode set.');
                    //_this.last_checked_online = Math.floor(+new Date() / 1000);
                    _this.offline=false;
                    _this.is_offline(false);
                    break;
                  default:
                    break;
                }
                break;
              case "set_offline_mode":

                break;
              default:
                break;
            }
          }
        }
        catch(ex)
        {
          console.error('fw-pwa-serviceworker_event:: Error occured in detail',ex);
        }
     });

    window.addEventListener('offline', function(e) {
      _this._log('debug','window.offline','Offline Mode set.');
      _this.last_checked_online = Math.floor(+new Date() / 1000);
      _this.offline=true;
      _this.is_offline(true);
    });

    window.addEventListener('online', function(e) {
      _this._log('debug','window.online','Online Mode set.');
      _this.last_checked_online = Math.floor(+new Date() / 1000);
      _this.offline=false;
      _this.is_offline(false);
    });

    // Setup user
    this.status = 'failed';
    this.profile = null;

    // Get profile from JWT
    if(await this._refresh_profile_from_token())
    {
      // Setup IndexDB
      this._setupDB();

      // Connect to user endpoint
      await this._connect_to_endpoint();

    }
    else
    {
      return false;
    }
  }

  async _connect_to_endpoint()
  {
    try
    {
      this.status = 'connecting';
      this._log('debug','init',"Connecting to user endpoint",this.url);
      // Set user
      this.dsbClient = new DatastoreBuilderClient({
              //endpoint: 'http://localhost:8000/fw/v1',
              endpoint: this.url,
              headers: {'Authorization': 'Bearer '+this.token, 'Content-Type': 'application/json'},
              bootstrap: '',
              hooks: ''
      });
      let init = await this.dsbClient.init();
      //TODO Test result to check token is all good
      this.status = 'complete';
    }
    catch(ex)
    {
      await this.is_offline('maintenance');
      this._log('error','reload',"Cannot connect to DatastoreBuilderClient", ex);
    }
  }

  hasJWTExpired()
  {
    if(this.profile && ('exp' in this.profile))
    {
      if(Math.floor(+new Date() / 1000) < this.profile.exp)
      {
        return false;
      }
      this._log('error','hasJWTExpired','Session seems to have expired',this.profile.exp);
    }
    return true;
  }

   async renew_session(changelayout = false)
  {
    if(this.refresh_url.length > 0)
    {
      return new Promise((resolve, reject) => {
        let didTimeOut = false;
        this._log('debug','renew_session',"Running...",this.refresh_url);
        let refresh_url = this.refresh_url+'&redirect='+encodeURIComponent(window.location.origin+'/wp-content/themes/pm-one-fwi/assets/images/fw-avatar.svg');
        try
        {
          let _this = this;
          //this._deleteCookie('pm_sso_jwt','/','/');
          document.cookie = "pm_sso_jwt=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/";
          if(!this._getCookie('pm_sso_jwt'))
          {
            const timeout = setTimeout(function() {
                didTimeOut = true;
                reject(new Error('Request timed out @'+_this.settings.online_check_timeout));
            }, _this.settings.online_check_timeout);

            this._log('debug','renew_session','Trying for a refresh with iframe to "'+refresh_url+'"');
            var iframe = document.createElement("iframe");
            iframe.setAttribute('src',refresh_url);
            iframe.setAttribute('class','hidden');
            iframe.onload = function() {
              clearTimeout(timeout);
              _this._log('debug','renew_session/iframe','iframe loaded',this);
              if(!didTimeOut)
              {
                _this._log('debug','renew_session/iframe','iframe returning true, deleting iframe',this);
                iframe.remove();
                resolve(true);
              }
            }
            document.body.append(iframe);
            return true;
          }
          else
          {
            this._log('error','renew_session','Cannot delete pm_sso_jwt cookie!')
            this.status = 'failed';
            //window.dispatchEvent(new CustomEvent('dsb-pwa-base_update', {detail: {"layout":"login"}}));
            reject('no-cookies');
          }
        }
        catch(ex)
        {
          this_log('error','renew_session',this.refresh_url,ex);
          this.status = 'failed';
          reject('error');
        }
      });
    }
    return false;
  }


  async _refresh_profile_from_token(auto_renew=true,force_login_on_fail=false)
  {
    this.token = this._getCookie(`pm_sso_jwt`);
    if(!this.token)
    {
      this._log('info','_refresh_profile_from_token','Missing token... '+(auto_renew?' running renew_session()':'auto_renew is off'));
      if(auto_renew)
      {
        await this.renew_session();
        return this._refresh_profile_from_token(false,force_login_on_fail);
      }
      else
      {
        if(force_login_on_fail)
        {
          return this.run_login_redirect(force_login_on_fail);
        }
        else
        {
          return false;
        }
      }
    }
    else
    {
      this._log('info','_refresh_profile_from_token','Ok found token, processing... ');
      var base64Url = this.token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      this.profile = JSON.parse(jsonPayload);

      if(this.hasJWTExpired())
      {
        this._log('info','_refresh_profile_from_token','JWT is Expired... '+(auto_renew?' running renew_session()':'auto_renew is off'));
        if(auto_renew)
        {
          await this.renew_session();
          return this._refresh_profile_from_token(false);
        }
        else
        {
          if(force_login_on_fail)
          {
            return this.run_login_redirect(force_login_on_fail);
          }
          else
          {
            return false;
          }
        }
      }
      else
      {
        this._log('info','_refresh_profile_from_token','Tokens fine and hasnt expired');
      }
    }
    return true;
  }

  get_login_url()
  {
    if(('login_url' in this.settings) && this.settings.login_url.length > 0)
    {
      return this.settings.login_url;
    }
    return false;
  }

  run_login_redirect(type=false)
  {
      if(('login_url' in this.settings) && this.settings.login_url.length > 0)
      {
        switch(type)
        {
          case "change_layout":
            this._log('debug','run_login_redirect','Launched layout login'+this.settings.login_url);
            //window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content:component}}));
            window.dispatchEvent(new CustomEvent('dsb-pwa-base_update', {detail: {"layout":"login"}}));
          default:
            this._log('debug','run_login_redirect','Redirecting to '+this.settings.login_url);
            window.location = this.settings.login_url;
            break;
        }
        return true;
      }
      return false;
  }

  async is_loggedin(role='',auto_renew=true,force_login_on_fail=false)
  {
    this._log('debug','is_loggedin','Checking for',{'role':role,'auto_renew':auto_renew});
    if(this.hasJWTExpired() && auto_renew)
    {
      if(await this._refresh_profile_from_token(auto_renew))
      {
        return this.is_loggedin(role,false);
      }
      else
      {
        if(force_login_on_fail)
        {
          return this.run_login_redirect(force_login_on_fail);
        }
        return false;
      }
    }
    else
    {
      this._log('debug','is_loggedin','JWT has not expired');
      if(this.profile)
      {
        if('role' in this.profile)
        {
          if(role)
          {
            if(role == this.profile.role)
            {
              return true;
            }
            return false;
          }
          else
          {
            switch(this.profile.role)
            {
              case "registered":
                this._log('info','is_loggedin',"Logged in as Registered user");
                return true;
              case "subscriber":
                this._log('info','is_loggedin',"Logged in as Subscriber user");
                return true;
              case "editor":
                this._log('info','is_loggedin',"Logged in as Editor user");
                return true;
              case "administrator":
                this._log('info','is_loggedin',"Logged in as Administrator user");
                return true;
              case "author":
                this._log('info','is_loggedin',"Logged in as Author user");
                return true;
              default:
                this._log('info','is_loggedin',"NOT Logged, Unknown role",this.profile.role);
                return false;
            }
          }
        }
      }
    }
    return false;
  }

  _setupDB()
  {
    if(this.profile && ('guid' in this.profile))
    {
      let db_tables = {};
      db_tables.local={
        "default":{
          'id':'string',
          'status':'string',
          'data':'object',
          'expirationdate':'date'
        },
        "generated_onupdate":{
          "lastupdate":"date"
        },
        "indexes":['status','expirationdate','lastupdate']
      };

      db_tables.data={
        "default":{
          'id':'string',//type|name|link|iteration"
          'type':'string',
          'name':'string',
          'link':'string',// link_type|link_value
          'status':'string',
          'expirationdate':'date',
          'createddate':'date',
          'acl':'string',
          'record':'object'
        },
        "generated_onupdate":{
          "lastupdate":"date"
        },
        "indexes":['type','status','link','name','expirationdate','acl','createddate','lastupdate']
      };

      db_tables.synch_pending={
        "default":{
          'id':'int',
          'status':'string',
          'target':'string',
          'params':'string',
          'data':'object'
        },
        "generated_onupdate":{
          "lastupdate":"date"
        },
        "indexes":['status','target','lastupdate']
      };

      /**
      db_tables.readprogress={
        "default":{
          'id':'int',
          'status':'string',
          'source':'string'
        },
        "generated_onupdate":{
          "lastupdate":"date"
        },
        "indexes":['status','source','lastupdate']
      };

      db_tables.general={
        "default":{
          'id':'string',
          'type':'string',
          'data':'object',
          'metadata':'object'
        },
        "generated_onupdate":{
          "lastupdate":"date"
        },
        "indexes":['type','lastupdate']
      };
      db_tables.readlater={
        "default":{
          'id':'string',
          'title':'string',
          'thumbnail':'path',
          'type':'string',
          'source':'string',
          'metadata':'object'
        },
        "generated_onupdate":{
          "lastupdate":"date"
        },
        "indexes":['type','source','lastupdate']
      };
      */

      this.local_db = new databaseHandler('fw-workbench_userdata__'+this.profile.guid,'1',db_tables);
    }
    else
    {
      console.error('dsb-app - UserHandler._setupDB:: Missing userid!');
    }
  }

  isConnected()
  {

    if(this.status == 'complete')
    {
      return true;
    }
    return false;
  }

  isPending()
  {
    if(this.status == 'pending')
    {
      return true;
    }
    return false;
  }

  resetUser()
  {
    this.profile = null;
  }

  getUserCookie(cname)
  {
    if(this.profile && ('guid' in this.profile))
    {
      return this._getCookie(cname+'___'+this.profile.guid);
    }
    return false;
  }

  setUserCookie(cname, cvalue, exdays)
  {
    if(this.profile && ('guid' in this.profile))
    {
      return this._setCookie(cname+'___'+this.profile.guid ,cvalue, exdays, '/',window.location.hostname);
    }
    return false;
  }

  deleteUserCookie(cname)
  {
    if(this.profile && ('guid' in this.profile))
    {
      return this._deleteCookie(cname+'___'+this.profile.guid ,'/', window.location.hostname);
    }
    return false;
  }

  _getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        let myCookie = c.substring(name.length, c.length);
        try
        {
          JSON.parse(myCookie);
          return myCookie;
        }
        catch (e)
        {
            return myCookie;
        }
      }
    }
    return "";
  }

  _setCookie(cname, cvalue, exdays=1, path='/', domain=false) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    if(domain)
    {
     document.cookie = cname + "=" + cvalue +";"+ expires + "; path="+path+"; SameSite=Strict; domain="+domain;
    }
    else
    {
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path="+path;
    }
  }


  _deleteCookie( name, path, domain ) {
    if( this._getCookie( name ) ) {
      console.log('Deleting cookie "'+name+'", path:"'+path+'", domain:"'+domain+'"');
      document.cookie = name + "=" +
        ((path) ? ";path="+path:"")+
        ((domain)?";domain="+domain:"") +
        ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
  }

  _updateCustomDimensions(customDimensions)
  {
    if(this.profile)
    {
      if('guid' in this.profile)
      {
        customDimensions['userid']=this.profile.guid;
      }
      else
      {
        console.error('dsb-app - UserHandler._updateGWA:: Missing userid!');
      }
      if('role' in this.profile)
      {
        customDimensions['usertype']=this.profile.role;
        customDimensions['authstatus']='logged in';
      }
      else
      {
        console.error('dsb-app - UserHandler._updateGWA:: Missing role!');
      }


      if('entitlements' in this.profile)
      {
          if (typeof this.profile.entitlements == "object")
          {
            var user_entitlements_append="";
            for(let anEntitlement in this.profile.entitlements)
            {
                if (anEntitlement!="missing") {
                    user_entitlements_append+=this.profile.entitlements[anEntitlement]+",";
                }
            };
            user_entitlements_append=user_entitlements_append.substr(0,(user_entitlements_append.length-1));
            customDimensions['userEntitlement']=user_entitlements_append;
          }
      }
      else
      {
        console.error('dsb-app - UserHandler._updateGWA:: Missing entitlements!');
      }


      if('demographics' in this.profile)
      {
        if('raw' in this.profile.demographics)
        {
            if (typeof this.profile.demographics.raw == "object")
            {
              var user_demographics_append="";
              for(let arawDemographic in this.profile.demographics.raw)
              {
                  let arawDemographic_val = 'ERROR';
                  if(Array.isArray(this.profile.demographics.raw[arawDemographic]))
                  {
                    arawDemographic_val = JSON.parse(JSON.stringify(this.profile.demographics.raw[arawDemographic]));
                    arawDemographic_val = arawDemographic_val.pop();
                  }
                  else
                  {
                    arawDemographic_val = this.profile.demographics.raw[arawDemographic];
                  }

                  if (arawDemographic!="missing") {
                      user_demographics_append+=arawDemographic.toUpperCase().replace(/ /g,'')+"_"+arawDemographic_val.toUpperCase().replace(/ /g,'')+"|";
                  }
              };
              user_demographics_append=user_demographics_append.substr(0,(user_demographics_append.length-1));
              customDimensions['userDemographic']=user_demographics_append;
            }
        }
        else
        {
            console.error('dsb-app - UserHandler._updateGWA:: Missing demographics.raw!');
        }
      }
      else
      {
        console.error('dsb-app - UserHandler._updateGWA:: Missing demographics!');
      }
      return customDimensions;
    }
    console.error('dsb-app - UserHandler._updateGWA:: Profile not available!');
  }

  format_date(timestamp, format='default',show_time=false)
  {
    var date = null;

    var return_date = '';

    const calculateTimimg = function (d){
      let months = 0, years = 0, days = 0, weeks = 0, total = d;
      while(d){
          if(d >= 365){
            years++;
            d -= 365;
          }else if(d >= 30){
            months++;
            d -= 30;
          }else if(d >= 7){
            weeks++;
            d -= 7;
          }else{
            days++;
            d--;
          }
      };
      return {
          years, months, weeks, days, total
      };
    };

    if(!isNaN(timestamp))
    {
      date = new Date(timestamp * 1000);
    }
    else
    {
      // Assume mysql timestamp
      /**
      console.debug(timestamp);
      let t = timestamp.split(/[- :]/);
      console.debug(t);
      date = new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5]));
      console.debug(date);
      */
      date = new Date(timestamp);
    }

    switch(format)
    {

      case "since":
          //calculate time difference
         var time_difference = new Date().getTime() - date.getTime();

         //calculate days difference by dividing total milliseconds in a day
         let dwmy = calculateTimimg(Math.trunc(time_difference / (1000 * 60 * 60 * 24)));

         let _return_date = [];

         if(('years' in dwmy) && dwmy.years>0)
         {
           _return_date.push(dwmy.years+' year'+(dwmy.years == 1?'':'s'));
         }

         if(('months' in dwmy) && dwmy.months>0)
         {
           _return_date.push(dwmy.months+' month'+(dwmy.months == 1?'':'s'));
         }

         if(('weeks' in dwmy) && dwmy.weeks>0)
         {
           _return_date.push(dwmy.weeks+' week'+(dwmy.weeks == 1?'':'s'));
         }

         if(('days' in dwmy) && dwmy.days>0)
         {
           _return_date.push(dwmy.days+' day'+(dwmy.days == 1?'':'s'));
         }

         return_date = dwmy;

         return_date.string = _return_date.join(", ");

         break;
      default:
        const nth = function(d) {
          if (d > 3 && d < 21) return 'th';
          switch (d % 10) {
            case 1:  return "st";
            case 2:  return "nd";
            case 3:  return "rd";
            default: return "th";
          }
        }

        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var year = date.getFullYear();
        var month = months[date.getMonth()];
        var day = date.getDate();

        // Hours part from the timestamp
        var hours = date.getHours();
        // Minutes part from the timestamp
        var minutes = "0" + date.getMinutes();

        // Will display time in YYYY/MM/DD 10:30:23 format
        if(show_time)
        {
          return_date = day+''+nth(day)+' '+month+' '+year+' at '+hours + ':' + minutes.substr(-2);
        }
        else
        {
          return_date = day+''+nth(day)+' '+month+' '+year;
        }
    }

    return return_date;
  }

  get_status()
  {
    return this.status;
  }

  async is_offline(suggested_offline_status=false,force=false)
  {
      let _this=this;
      let didTimeOut = false;
      let run_fetch = true;
      if(!_this.settings.online_check_url)
      {
        _this._log('error','Missing online check url!');
        run_fetch=false;
      }
      else
      {
        //_this._log('debug','Fetch using online_check_url...',_this.settings.online_check_url);
      }

      if(suggested_offline_status)
      {
        force=true;
      }

      if(!force)
      {
        let last_five_min = ((Math.floor(+new Date() / 1000))-(5 * 60));
        if(_this.last_checked_online && (_this.last_checked_online > last_five_min))
        {
          //_this._log('debug','is_offline','Skipping check '+_this.last_checked_online+' > '+last_five_min);
          run_fetch=false;
        }
        else
        {
          //_this._log('debug','is_offline','Will check '+_this.last_checked_online+' > '+last_five_min);
        }
      }
      else
      {
        _this._log('debug','is_offline','Check forced!');
      }

      return new Promise(function(resolve, reject) {
          if(!run_fetch)
          {
            //_this._log('warning','is_offline','fetch off',run_fetch);
            resolve(_this.offline);
          }
          else
          {
            _this._log('log','is_offline','Looking for net....');
            const timeout = setTimeout(function() {
                didTimeOut = true;
                reject(new Error('Request timed out @'+_this.settings.online_check_timeout));
            }, _this.settings.online_check_timeout);

            fetch(_this.settings.online_check_url+'#sw:no-cache')
            .then(function(response) {
                // Clear the timeout as cleanup
                clearTimeout(timeout);
                if(!didTimeOut) {
                    _this._log('log','is_offline','fetch worked', response);
                    if(('status' in response) && response.status != 503)
                    {
                      _this.last_checked_online = Math.floor(+new Date() / 1000);
                      resolve(false);
                    }
                    else
                    {
                      resolve(true);
                    }
                }
            })
            .catch(function(err) {
                _this._log('error','is_offline','fetch failed! ', err);

                // Rejection already happened with setTimeout
                if(didTimeOut) return;
                // Reject with error
                reject(err);
            });
          }
      })
      .then(function(response) {

          if(typeof response == "boolean")
          {
            _this.offline=response;
          }
          else
          {
            _this.offline=suggested_offline_status;
          }
          if(_this._offline!=_this.offline)
          {
            if(_this.offline)
            {
              _this._log('info','is_offline','Offline (inherited)',[_this.offline,response]);
            }
            else
            {
              _this._log('info','is_offline','Online',_this.offline,response);
            }
            window.dispatchEvent(new CustomEvent('fw-workspace-offline_status', {detail:_this.offline}));
          }
          _this._offline=_this.offline;
          return _this.offline;
      })
      .catch(function(err) {
          _this.offline=true;
          _this._log('error','is_offline','Offline', err);
          if(_this._offline!=_this.offline)
          {
            window.dispatchEvent(new CustomEvent('fw-workspace-offline_status', {detail:_this.offline}));
          }
          _this._offline=_this.offline;
          return _this.offline;
      });
  }

   _log(type,source,message,data='')
  {
    let _message = 'fw-workbench/UserHandler::'+source+'- '+message;
    switch(type)
    {
       case "debug":
         console.debug(_message,data);
        break;
      case "warning":
         console.warn(_message,data);
      case "info":
         console.info(_message,data);
        break;
      case "error":
         console.error(_message,data);
        break;
      default:
          console.log(_message,data);
    }
  }

  has_localdb()
  {
    return (this.local_db?true:false);
  }

  getDate()
  {
    return Math.floor(+new Date() / 1000) ;
  }

  async resetCache(target)
  {
    if(target)
    {
       this.cache[target] = {};
    }
    else
    {
      this.cache = {};
    }
    console.info('dsb-app - UserHandler:: Reset Cache');
  }

  async _sha256(message) {

    // encode as UTF-8
    const msgBuffer = new TextEncoder('utf-8').encode(message);

    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convert bytes to hex string
    const hashHex = hashArray.map(b => ('00' + b.toString(16)).slice(-2)).join('');
    return hashHex;
  }

  async get(target,query,firstOnly = false, force = false)
  {

    let id = target+"|"+query+"|"+firstOnly;
    let json = {};

    if(!force)
    {
      let clean_target = target.replace('local_','');
      if(this.has_localdb && this.local_db.handles_table(clean_target))
      {
        let indexes = Object.fromEntries(new URLSearchParams(query));
        let data = false;
        if('id' in indexes)
        {
          data =  this.local_db.get(clean_target,'id',indexes.id);
        }
        else
        {
          data =  this.local_db.get(clean_target,'index',indexes);
        }
        if(firstOnly && Array.isArray(data))
        {
          return data[0];
        }
        return data;
      }
      else
      {
        if(target in this.cache)
        {
          if(id in this.cache[target])
          {
            return this.cache[target][id];
          }
        }
      }
    }

    if(this.offline)
    {
      console.error('dsb-app - UserHandler.get:: Offline');
      return false;
    }

    switch(target)
    {
      default:
        json = await this.dsbClient.get(target,query);
        break;
    }

    if('data' in json)
    {
      if(firstOnly)
      {
        if(Array.isArray(json.data))
        {
          if(Object.keys(json.data).length === 0)
          {
            //Ok
          }
          else
          {
            json.data = json.data[0];
          }
        }
      }
      if (json.state)
      {
        if(!(target in this.cache))
        {
          this.cache[target] = {};
        }
        this.cache[target][id] = json.data;
      }

      return json.data;
    }
    return false;
  }

  async post(target,data,allow_offline=false)
  {

    if(target.startsWith('local_') || target==='local')
    {
      allow_offline=true;
    }

    if(this.offline)
    {
      if(!allow_offline)
      {
        console.error('dsb-app - UserHandler.post:: Offline');
        return false;
      }
    }
    else
    {
      // Reset cache for this target
      if(target in this.cache)
      {
        this.cache[target] = {};
      }
    }

    target = target.split('?');
    let params = '';
    if(target[1])
    {
      params = target[1];
    }
    target = target[0];
    let json = {};
    try
    {
      switch(target)
      {
        case "local":
          if(this.has_localdb && ('id' in data))
          {
            return await this.local_db.upsert('local',data.id,data);
          }
          break;
        case "local_data":
          if(this.has_localdb)
          {
             return await this.local_db.upsert('data',data.id,data);
          }
          break;
        /**
        case "readprogress":
          if(!('id' in data))
          {
              throw 'Missing id in readprogress';
          }
          let done_localdb = false;
          let done_remotedb = false;
          let done_synchpending = false;
          let all_readprogress = false;
          if(this.has_localdb)
          {
            done_localdb = await this.local_db.upsert('readprogress',data.id, data);
            all_readprogress = await this.local_db.get('readprogress','all');
            all_readprogress = {'type':'record','name':'readprogress','status':'published','data':all_readprogress}
          }
          if(!this.offline)
          {
            if(all_readprogress)
            {
              json = await this.dsbClient.post('data',params,all_readprogress);
              if (json.state && json.state == 'success')
              {
                done_remotedb = true;
              }
            }
          }


          if(!done_remotedb && all_readprogress)
          {
            done_synchpending = this.local_db.upsert('synch_pending',"readprogress",{'status':'qued','target':target,'params':params,'data':all_readprogress});
          }

          return (!done_remotedb?(!done_localdb?'error_localdb':(!done_synchpending?'error_synchpending':'synch_pending')):'success');
          break;
         */
        case "data":
          json = await this.dsbClient.post(target,params,data);
          if (json.state)
          {
            return json.data;
          }
          break;
        case "cpd":
            let remove = ['id','user_id','progress', 'points','status', 'created_date', 'update_date'];
            for(let i =0; i<remove.length; i++)
            {
              if(Array.isArray(data))
              {
                for(let ii =0; ii<data.length; ii++)
                {
                  if(remove[i] in data[ii])
                  {
                    delete data[ii][remove[i]];
                  }
                }
              }
              else
              {
                if(remove[i] in data)
                {
                  delete data[remove[i]];
                }
              }
            }
            json = await this.dsbClient.post(target,params,data);
            if (json.state)
            {
              return json.data;
            }
            break;
        default:
          break;
      }
    }
    catch(ex)
    {
      console.error(ex);
    }
    return false;

  }

}


